import { Contact, Layout } from '@rumblefish/ui/Rumblefish23Theme';

import { NextHeadWithMeta } from '../NextHeadWithMeta';
import type { AiChatServicePageProps } from './aiChatService.types';
import { aiChatServicePageSeo } from './aiChatServicePage.seo';
import { Benefits } from './Benefits';
import { ChatbotServices } from './ChatbotServices';
import { ChatUseCases } from './ChatUseCases';
import { Faq } from './Faq';
import { Hero } from './Hero';
import { TechStack } from './TechStack';
import { OurWork } from './OurWork';

export const AiChatServicePage = ({
  blogPosts,
  caseStudies,
}: AiChatServicePageProps) => {
  return (
    <Layout blogPosts={blogPosts}>
      <NextHeadWithMeta {...aiChatServicePageSeo} />
      <Hero />
      <ChatbotServices />
      <ChatUseCases />
      <Benefits />
      <TechStack />
      <OurWork caseStudies={caseStudies} />
      <Faq />
      <Contact
        color="magenta"
        subtitle="We will answer any questions you may have related to your custom AI chatbot!"
      />
    </Layout>
  );
};
